module.exports = __webpack_public_path__ + "images/tips/inspiration-1@1x.e1565bd541d2b56ec792.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/inspiration-1@1x.png
// module id = YDNV
// module chunks = 13